<template>
    <div class="itin-flight">
        <div class="itin-passengers-content bag-flex group row">
            <div class="col my-auto text-left p-5">
                <h3>{{ $t('Si usted tiene necesidades específicas, comuníquese al') }} <strong>0810-777-2633</strong>.</h3>
                <ul>
                    <li>{{ $t('Pasajero con sillas de ruedas.') }}</li>
                    <li>Menores viajando solos.</li>
                    <li>{{ $t('Servicio de Asistencia en Aeropuerto.') }}</li>
                    <li>Registrar animales en bodega.</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'extras-message',
  }
</script>
